import idiomsFromJson from "#idioms.json" with { type: "json" };

export const idioms = idiomsFromJson;

/** Exact, contiguous occurrences, in either script; the expression itself is excluded. */
export function findContainingIdioms(word: string) {
  if (word.length === 0) {
    return [];
  }
  return idioms.filter(
    (idiom) =>
      idiom.simplified !== word &&
      idiom.traditional !== word &&
      (idiom.simplified.includes(word) || idiom.traditional.includes(word)),
  );
}
